import React, { Component } from "react";
import styled from "styled-components";

import { DEFAULT_YT_VIDEO_ID } from "../../config";
import { Box } from "../../comps";

const IFrameWrapper = styled(Box)`
  width: 100%;
  height: 100%;
`;

export default () => {
  return (
    <IFrameWrapper>
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${DEFAULT_YT_VIDEO_ID}?autoplay=1&mute=1`}
        frameborder="0"
        autoplay
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </IFrameWrapper>
  );
};
